import React from 'react';
import { useParams } from 'react-router-dom';
import { Breadcrumbs, BreadcrumbsItem, PageHeader, PageHeaderContent } from 'components';
import { URL } from 'routes/routeConstants';
import { PayoutMethodTypes } from 'types';

interface IMakePaymentHeaderProps {
  pageHeaderContent?: React.ReactNode;
}

const MakePaymentHeader = ({ pageHeaderContent, ...rest }: IMakePaymentHeaderProps) => {
  const routeParams = useParams<{ step?: PayoutMethodTypes }>();
  const payoutMethods = Object.values(PayoutMethodTypes);
  const includePayoutMethodCrumb = payoutMethods.includes(routeParams?.step);

  return (
    <PageHeader {...rest}>
      <Breadcrumbs data-cy="payments-breadcrumbs">
        <BreadcrumbsItem data-cy="payments-breadcrumblink" label="Payments" to={URL.PaymentsOverview} />
        <BreadcrumbsItem data-cy="make-payments-breadcrumblink" label="Make Payment" to={URL.MakePayment} />
        {includePayoutMethodCrumb && <BreadcrumbsItem data-cy={`make-payments-${routeParams.step}-breadcrumblink`} label={routeParams.step} />}
      </Breadcrumbs>

      <PageHeaderContent>{pageHeaderContent && pageHeaderContent}</PageHeaderContent>
    </PageHeader>
  );
};

export default MakePaymentHeader;
